import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface BookingsListCardTitleProps {
  icon: LucideIcon;
  title: string;
  /** Count pill after the title (hidden when null). */
  count?: number | null;
  /** Secondary text after the count (e.g. "3 bookings need your attention"). */
  subtitle?: string | null;
  iconClassName?: string;
  className?: string;
}

/** Card title for booking lists: icon well + title + count pill + optional subtitle. */
export function BookingsListCardTitle({
  icon: Icon,
  title,
  count,
  subtitle,
  iconClassName,
  className,
}: BookingsListCardTitleProps) {
  return (
    <span
      className={cn(
        "flex min-w-0 flex-wrap items-center gap-x-2.5 gap-y-1",
        className,
      )}
    >
      <span className="flex min-w-0 items-center gap-2.5">
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-surface-200 bg-surface-50 text-surface-600">
          <Icon className={cn("h-4 w-4", iconClassName)} aria-hidden />
        </span>
        <span className="truncate">{title}</span>
        {count != null ? (
          <span className="rounded-md bg-surface-100 px-1.5 py-0.5 text-xs font-medium tabular-nums text-surface-600">
            {count}
          </span>
        ) : null}
      </span>
      {subtitle ? (
        <span className="text-[13px] font-normal text-surface-500">
          {subtitle}
        </span>
      ) : null}
    </span>
  );
}
